import { toExcelAmount, toExcelDate } from 'components/xlsx/excelCells';
import { ClassifierData } from 'types/classifiers';
import { ExpenseExportListItemDto } from 'types/expenses';
import { getClassifierText, t } from 'utils/getTranslations';

export const mapExpensesToCSVFormat = (
    expenses: ExpenseExportListItemDto[],
    classifiers: Record<string, ClassifierData>
) => {
    return expenses?.map((expense) => {
        return {
            [t('expenses.export.connected-client')]: expense?.matter?.clientParty?.name,
            [t('expenses.export.case-name')]: expense?.matter?.fullName,
            [t('expenses.export.invoice-number')]: expense?.invoices
                ?.map((invoice) => invoice.invoiceNumber)
                .join(', '),
            [t('expenses.export.date')]: toExcelDate(expense.expenseDate),
            [t('expenses.export.colleague')]: expense?.employee?.name,
            [t('expenses.export.belongs-to-company')]: expense?.employment?.company?.name,
            [t('expenses.export.expense-type')]: getClassifierText(
                classifiers['EXPENSE_TYPE'],
                expense.expenseTypeCode
            ),
            [t('expenses.export.details-of-expense')]: expense.description,
            [t('expenses.export.currency')]: expense.currencyTypeCode,
            [t('expenses.export.amount')]: toExcelAmount(expense.expenseAmount),
            [t('expenses.export.original-currency')]: expense.originalCurrencyTypeCode,
            [t('expenses.export.original-amount')]: toExcelAmount(expense.expenseAmountOriginalCurrency),
            [t('expenses.export.non-billable')]: expense.isNonBillable,
            [t('expenses.export.external-id')]: expense.externalId ?? '',
            // The export needs "TRUE/FALSE" string values here, not raw booleans (the older
            // `non-billable` column emits booleans for back-compat).
            [t('expenses.export.connected-to-bd-effort')]: expense.isConnectedToEffort ? 'TRUE' : 'FALSE',
        };
    });
};
